import { HttpInjector } from '@/cowboy/http/HttpInjector'
import { CreatePaymentSessionResponse } from '@/cowboy/payment/object/CreatePaymentSessionResponse'

export class DirectPaymentApi extends HttpInjector {
  /**
   * Creates the ingo session for the Ingo Iframe
   * @return {Promise<CreatePaymentSessionResponse>}
   */
  static async createIngoSession () {
    const response = await this.$http.post('/direct-payments/session', { host: window.location.origin })
    return this.cast(response.data, CreatePaymentSessionResponse)
  }
}
